module.exports = __webpack_public_path__ + "img/me.b7d4f601.jpg";